module.exports = __webpack_public_path__ + "img/barrage_prize_an_on.788a7a4e.png";